$('.slider').slick({
  autoplay: true, //自動的に動き出すか。初期値はfalse。
  autoplaySpeed: 5000,
  infinite: true, //スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 1, //スライドを画面に3枚見せる
  slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
  centerMode: true,
  centerPadding: '0',
  variableWidth: true,
  dots: true, //下部ドットナビゲーションの表示
});
